'use client';

import { token } from '@terra/ui-styled-system';
import type { MemoryStatus } from '@terra/shared-contracts-memory';
import type { TerraIcon } from '@terra/ui-icons';
import {
  CheckmarkCircle02Icon,
  RefreshIcon,
  CancelCircleIcon,
} from '@terra/ui-icons';
import { Badge, type BadgeProps } from '../badge';

export type BadgeMemoryStatusProps = Omit<BadgeProps, 'icon'> & {
  status: MemoryStatus;
};
type BadgeMemoryStatusConfig = {
  icon: TerraIcon;
  iconColor: string;
};

export const BADGE_MEMORY_STATUS_CONFIG: Record<
  MemoryStatus,
  BadgeMemoryStatusConfig
> = {
  active: {
    icon: CheckmarkCircle02Icon,
    iconColor: token('colors.fg.status.resolved'),
  },
  pending: {
    icon: RefreshIcon,
    iconColor: token('colors.fg.status.inProgress'),
  },
  rejected: {
    icon: CancelCircleIcon,
    iconColor: token('colors.fg.status.unresolved'),
  },
};
export const BadgeMemoryStatus = ({
  status,
  variant = 'outline',
  size = 'sm',
  children,
  ...props
}: BadgeMemoryStatusProps) => {
  const config = BADGE_MEMORY_STATUS_CONFIG[status];
  const StatusIcon = config.icon;

  return (
    <Badge
      variant={variant}
      size={size}
      icon={<StatusIcon size={16} color={config.iconColor} />}
      {...props}
    >
      {children}
    </Badge>
  );
};
